import { BaseDropdown } from './component/BaseDropdown';
import { useDropdownOptions } from '../../hooks/useDropdownOptions';
import { BusinessDropdownProps } from './component/type';

const COLUMN_NAMES = ['language', 'Description'];

export const LanguagesDropdown = (props: BusinessDropdownProps) => {
  const shouldPreventApiCall = props.disabled || props.readOnly;

  const { options, loading } = useDropdownOptions({
    apiId: 'internal.v1.base-tables',
    operationId: 'GET /promptValues/{windowId}',
    labelAttribute: 'description',
    valueAttribute: 'language',
    params: { windowId: 'languages' },
    shouldPreventApiCall,
  });

  return <BaseDropdown {...props} loading={loading} options={options} columnNames={COLUMN_NAMES} />;
};
